(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
(() => {
  const initializeProductReviewNavigation = () => {
    const main = document.getElementById('MainContent');
    if (!main?.querySelector('product-info[data-fieri-review-navigation]')) return;
    const header = document.querySelector('.section-header');
    const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let updatePending = false;

    const updateHeaderMargin = () => {
      const height = header?.getBoundingClientRect().height || 0;
      main.querySelectorAll('.fieri-product-review-target').forEach((target) => {
        target.style.setProperty('--fieri-review-header-height', height + 'px');
      });
    };

    const replaceRatingElement = (row, tag) => {
      const replacement = document.createElement(tag);
      Array.from(row.attributes).forEach((attribute) => {
        replacement.setAttribute(attribute.name, attribute.value);
      });
      while (row.firstChild) replacement.appendChild(row.firstChild);
      row.replaceWith(replacement);
      return replacement;
    };

    const updateReviewLinks = () => {
      updatePending = false;
      const widget = main.querySelector('#judgeme_product_reviews');
      const target = widget?.closest('.shopify-section');
      const available = target?.id && !widget.hidden &&
        getComputedStyle(widget).display !== 'none' && getComputedStyle(target).display !== 'none';

      main.querySelectorAll('product-info[data-fieri-review-navigation] [data-fieri-review-count]').forEach((row) => {
        if (available && Number(row.dataset.fieriReviewCount) > 0) {
          const link = row.tagName === 'A' ? row : replaceRatingElement(row, 'a');
          link.classList.add('fieri-product-review-link');
          link.setAttribute('href', '#' + target.id);
          link.setAttribute('aria-label', link.dataset.fieriReviewLabel);
          target.classList.add('fieri-product-review-target');
          target.setAttribute('tabindex', '-1');
        } else if (row.tagName === 'A') {
          const text = replaceRatingElement(row, 'div');
          text.classList.remove('fieri-product-review-link');
          text.removeAttribute('href');
          text.removeAttribute('aria-label');
        }
      });
      updateHeaderMargin();
    };

    const scheduleUpdate = () => {
      if (updatePending) return;
      updatePending = true;
      requestAnimationFrame(updateReviewLinks);
    };

    main.addEventListener('click', (event) => {
      const link = event.target.closest('a.fieri-product-review-link');
      if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const target = document.getElementById(link.hash.slice(1));
      if (!target) return;
      event.preventDefault();
      updateHeaderMargin();
      window.history.pushState(null, '', link.hash);
      target.focus({ preventScroll: true });
      target.scrollIntoView({ behavior: motion.matches ? 'instant' : 'smooth', block: 'start' });
    });

    new MutationObserver(scheduleUpdate).observe(main, { childList: true, subtree: true });
    if (header && typeof ResizeObserver !== 'undefined') {
      new ResizeObserver(updateHeaderMargin).observe(header);
    }
    window.addEventListener('resize', updateHeaderMargin, { passive: true });
    updateReviewLinks();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeProductReviewNavigation, { once: true });
  } else {
    initializeProductReviewNavigation();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
